// import * as React from 'react';
// import { useState, useEffect } from 'react';
// import {
//   Box,
//   Stack,
//   Container,
//   Typography,
//   Snackbar,
//   Alert,
//   Button,
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Paper,
//   Checkbox,
//   IconButton,
//   Tabs,
//   Tab,
//   Menu,
//   MenuItem,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Pagination,
//   CircularProgress,
//   PaginationItem,
//   DialogContentText,
//   Rating,
//   Grid
// } from '@mui/material';
// import { Link, useNavigate } from 'react-router-dom';
// import { Link as RouterLink } from 'react-router-dom';

// //components
// import Page from '../../components/Page';
// import Iconify from 'src/components/Iconify';

// //icons
// import Empty_Truck from '../../../src/asset/open-door.png';
// import { Add, Remove } from '@mui/icons-material';
// import { LoadingButton } from '@mui/lab';
// import { api } from 'src/Api';
// import moment from 'moment';
// import { NumericFormat } from 'react-number-format';
// import Searchbar from 'src/layouts/dashboard/Searchbar';

// export default function TruckShipmentRequest() {
//   const navigate = useNavigate();
//   const userData = JSON.parse(localStorage.getItem('user'));

//   const [shipmentList, setShipmentList] = useState([]);

//   const [selectedTab, setSelectedTab] = useState(0); // State to handle the active tab
//   const [loading, setloading] = useState(false);
//   const [optionsLoader, setOptionsLoader] = useState(false);
//   const [extendLoading, setExtendLoading] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');

//   const [optionNumber, setOptionNumber] = useState('');

//   const [openAlertModal, setOpenAlertModal] = useState(false);
//   const [openRatingModal, setOpenRatingModal] = useState(false);

//   const [pagesCount, setpagesCount] = useState(1);
//   const [page, setPage] = useState(1);

//   const [selected, setSelected] = useState([]); // To hold selected truck objects
//   const [anchorEl, setAnchorEl] = useState(null); // For 3-dot menu control
//   const [selectedTruck, setSelectedTruck] = useState(null); // Track which truck is selected for menu

//   const [open, setOpen] = useState(false);
//   const [days, setDays] = useState(1);

//   const [rating, setRating] = useState(0);
//   const [review, setReview] = useState('');

//   const [selectLoad, setSelectLoad] = useState('');
//   const [openDetailsModal, setOpenDetailsModal] = useState(false);
//   const [searchLoading, setsearchLoading] = useState(false);
//   const [search, setsearch] = useState('');

//   useEffect(() => {
//     if (search.length == 0) {
//       shipmentList.length = 0;
//       getShipmentList(page);
//     }
//   }, [search]);

//   useEffect(() => {
//     getShipmentList(page);
//   }, [page]);

//   function getShipmentList(page) {
//     setloading(true);
//     const myHeaders = new Headers();

//     const token = localStorage.getItem('token');
//     myHeaders.append('Authorization', `Bearer ${token}`);

//     const requestOptions = {
//       method: 'GET',
//       headers: myHeaders,
//       redirect: 'follow'
//     };

//     const queryParams = new URLSearchParams();
//     search.length > 0 && queryParams.append('search', search);
//     page && queryParams.append('page', page);

//     fetch(`${api.get_shipment}?${queryParams.toString()}`, requestOptions)
//       .then((response) =>
//         response.text().then((result) => ({ status: response.status, body: result }))
//       )
//       .then(({ status, body }) => {
//         const result = JSON.parse(body);
//         if (status === 200) {
//           setShipmentList(result.data);
//           result?.count ? setpagesCount(Math.ceil(result?.count / 10)) : setpagesCount(1);
//           setloading(false);
//           setsearchLoading(false);
//         } else {
//           setShipmentList([]);
//           setpagesCount(0);
//           setloading(false);
//           setsearchLoading(false);
//         }
//       })
//       .catch((error) => {
//         console.log('error', error);
//         setloading(false);
//         setsearchLoading(false);
//       });
//   }

//   // const isAllSelected = selected.length === shipmentList.length;
//   const isAllSelected =
//     selected.length ===
//     shipmentList.filter((truck) => truck.status.toLowerCase() !== 'expired').length;

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   // Toggle individual row selection
//   const handleSelectRow = (truck) => {
//     const selectedIndex = selected.findIndex((item) => item === truck);

//     if (selectedIndex > -1) {
//       setSelected(selected.filter((item) => item !== truck)); // Deselect if already selected
//     } else {
//       setSelected([...selected, truck]); // Add truck to selected array
//     }
//   };

//   // Toggle select all rows
//   const handleSelectAll = () => {
//     const nonExpiredShipments = shipmentList.filter(
//       (truck) => truck.status.toLowerCase() !== 'expired'
//     );
//     if (isAllSelected) {
//       setSelected([]); // Deselect all
//     } else {
//       setSelected(nonExpiredShipments); // Select only non-expired trucks
//     }
//   };

//   const handleMenuClick = (event, truck) => {
//     setAnchorEl(event.currentTarget);
//     setSelectedTruck(truck); // Set the truck for which menu is open
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//     setSelectedTruck(null); // Reset the selected truck
//   };

//   const handleOptionSelect = (option) => {
//     setOptionNumber(option);
//     if (selected.length == 0) {
//       ChangeShipmentStatus(option);
//     } else {
//       ChangeBulkShipmentStatus(option);
//     }
//   };

//   const handleTabChange = (event, newValue) => {
//     setSelectedTab(newValue); // Switch the tab based on user selection
//   };

//   const handleClickOpen = () => {
//     setOpen(true);
//     setAnchorEl(null);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   const handleIncrement = () => {
//     setDays((prevDays) => prevDays + 1);
//   };

//   const handleDecrement = () => {
//     setDays((prevDays) => (prevDays > 1 ? prevDays - 1 : 1)); // Ensure at least 1 day
//   };

//   const handlePageChange = (event, value) => {
//     shipmentList.length = 0;
//     setPage(value);
//     getShipmentList(value);
//   };

//   // extend_pickup_date_shipment
//   function ExtendDaysFuntion() {
//     setExtendLoading(true);
//     const myHeaders = new Headers();

//     const token = localStorage.getItem('token');
//     myHeaders.append('Authorization', `Bearer ${token}`);

//     const formdatas = new FormData();
//     selected && formdatas.append('id', selectedTruck?.id);
//     formdatas.append('days', days);

//     const requestOptions = {
//       method: 'POST',
//       headers: myHeaders,
//       body: formdatas,
//       redirect: 'follow'
//     };

//     fetch(api.extend_pickup_date_shipment, requestOptions)
//       .then((response) =>
//         response.text().then((result) => ({ status: response.status, body: result }))
//       )
//       .then(({ status, body }) => {
//         const result = JSON.parse(body);
//         if (status === 200 || status === 201) {
//           setSnackbarMessage(result.message);
//           setSnackbarSeverity('success');
//           setSnackbarOpen(true);
//           setExtendLoading(false);
//           handleClose();
//           setDays(1);
//           getShipmentList(page);
//         } else {
//           setExtendLoading(false);
//           setSnackbarMessage(result.message);
//           setSnackbarSeverity('error');
//           setSnackbarOpen(true);
//         }
//       })
//       .catch((error) => {
//         setExtendLoading(false);
//         setSnackbarMessage('An error occurred.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       });
//   }

//   // change_shipment_status
//   function ChangeShipmentStatus(status) {
//     setOptionsLoader(true);
//     const myHeaders = new Headers();

//     const token = localStorage.getItem('token');
//     myHeaders.append('Authorization', `Bearer ${token}`);

//     const formdatas = new FormData();
//     selected && formdatas.append('id', selectedTruck?.id);
//     formdatas.append('status', status);

//     const requestOptions = {
//       method: 'POST',
//       headers: myHeaders,
//       body: formdatas,
//       redirect: 'follow'
//     };

//     fetch(api.change_shipment_status, requestOptions)
//       .then((response) =>
//         response.text().then((result) => ({ status: response.status, body: result }))
//       )
//       .then(({ status, body }) => {
//         const result = JSON.parse(body);
//         if (status === 200 || status === 201) {
//           setSnackbarMessage(result.message);
//           setSnackbarSeverity('success');
//           setSnackbarOpen(true);
//           setOptionsLoader(false);
//           handleMenuClose();
//           handleCloseAlert();
//           getShipmentList(page);
//           setOptionNumber('');
//         } else {
//           setOptionsLoader(false);
//           setSnackbarMessage(result.message);
//           setSnackbarSeverity('error');
//           setSnackbarOpen(true);
//         }
//       })
//       .catch((error) => {
//         setOptionsLoader(false);
//         setSnackbarMessage('An error occurred.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       });
//   }

//   // add_rating_review
//   function handleAddRatingReview() {
//     setOptionsLoader(true);
//     const myHeaders = new Headers();

//     const token = localStorage.getItem('token');
//     myHeaders.append('Authorization', `Bearer ${token}`);

//     const formdatas = new FormData();
//     selected && formdatas.append('booking_id', selectedTruck?.id);
//     rating && formdatas.append('rating', rating);
//     review && formdatas.append('review', review);

//     const requestOptions = {
//       method: 'POST',
//       headers: myHeaders,
//       body: formdatas,
//       redirect: 'follow'
//     };

//     fetch(api.mark_as_complete, requestOptions)
//       .then((response) =>
//         response.text().then((result) => ({ status: response.status, body: result }))
//       )
//       .then(({ status, body }) => {
//         const result = JSON.parse(body);
//         if (status === 200 || status === 201) {
//           setSnackbarMessage(result.message);
//           setSnackbarSeverity('success');
//           setSnackbarOpen(true);
//           handleMenuClose();
//           handleCloseRating();
//           getShipmentList(page);
//           setOptionsLoader(false);
//         } else {
//           setOptionsLoader(false);
//           setSnackbarMessage(result.error);
//           setSnackbarSeverity('error');
//           setSnackbarOpen(true);
//         }
//       })
//       .catch((error) => {
//         setOptionsLoader(false);
//         setSnackbarMessage('An error occurred.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       });
//   }

//   // change_bulk_shipment_status
//   function ChangeBulkShipmentStatus(status) {
//     setOptionsLoader(true);
//     const myHeaders = new Headers();

//     const token = localStorage.getItem('token');
//     myHeaders.append('Authorization', `Bearer ${token}`);

//     const formdatas = new FormData();
//     if (selected && selected.length > 0) {
//       const selectedIds = selected.map((item) => item.id);
//       formdatas.append('ids', selectedIds);
//     }
//     formdatas.append('status', status);

//     const requestOptions = {
//       method: 'POST',
//       headers: myHeaders,
//       body: formdatas,
//       redirect: 'follow'
//     };

//     fetch(api.change_bulk_shipment_status, requestOptions)
//       .then((response) =>
//         response.text().then((result) => ({ status: response.status, body: result }))
//       )
//       .then(({ status, body }) => {
//         const result = JSON.parse(body);
//         if (status === 200 || status === 201) {
//           setSnackbarMessage(result.message);
//           setSnackbarSeverity('success');
//           setSnackbarOpen(true);
//           setOptionsLoader(false);
//           setSelected([]);
//           handleMenuClose();
//           getShipmentList(page);
//           setOptionNumber('');
//         } else {
//           setOptionsLoader(false);
//           setSnackbarMessage(result.message);
//           setSnackbarSeverity('error');
//           setSnackbarOpen(true);
//         }
//       })
//       .catch((error) => {
//         setOptionsLoader(false);
//         setSnackbarMessage('An error occurred.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       });
//   }

//   const handleOpenAlert = () => {
//     setOpenAlertModal(true);
//   };

//   const handleCloseAlert = () => {
//     setOpenAlertModal(false);
//   };

//   const handleOpenRating = () => {
//     setOpenRatingModal(true);
//   };

//   const handleCloseRating = () => {
//     setOpenRatingModal(false);
//     setRating(0);
//     setReview('');
//   };

//   const handleRatingChange = (event, newValue) => {
//     setRating(newValue);
//   };

//   const handleReviewChange = (event) => {
//     setReview(event.target.value);
//   };

//   const handleOpenDetailsModal = () => {
//     setOpenDetailsModal(true);
//     setAnchorEl(null);
//   };
//   const handleCloseDetailsModal = () => {
//     setOpenDetailsModal(false);
//   };

//   return (
//     <Page title={`My Shipments | ${process.env.REACT_APP_PROJECTNAME}`}>
//       <Container>
//         <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={2}>
//           <IconButton
//             style={{
//               marginRight: 12,
//               height: 40,
//               width: 70,
//               borderRadius: 5,
//               backgroundColor: 'rgba(209,209,209,0.3)'
//             }}
//             onClick={() => navigate(-1)}
//           >
//             <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#010f58' }} />
//           </IconButton>
//           <Typography variant="h4" sx={{ color: '#010f58' }}>
//             Request a Shipment
//           </Typography>
//         </Stack>

//         <Box
//           style={{
//             flexDirection: 'column',
//             display: 'flex',
//             flex: 1,
//             marginTop: 10
//           }}
//           className="top_column"
//         >
//           <Box
//             style={{
//               flexDirection: 'row',
//               display: 'flex',
//               flex: 1
//             }}
//             className="top_column"
//           >
//             <Searchbar
//               width={'100%'}
//               fullWidth
//               setFunction={(val) => {
//                 setsearch(val);
//               }}
//               className="width_full_property"
//               placeholder={'Search Requests'}
//               onEnter={() => {
//                 setsearchLoading(true);
//                 shipmentList.length = 0;
//                 getShipmentList();
//               }}
//             />
//             <LoadingButton
//               style={{ width: '15%', marginLeft: '2.5%' }}
//               variant="contained"
//               className="width_full_status"
//               loading={searchLoading}
//               onClick={() => {
//                 setsearchLoading(true);
//                 setPage(1);
//                 getShipmentList(1);
//               }}
//             >
//               <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
//             </LoadingButton>
//           </Box>
//         </Box>

//         {/* Content */}
//         <TableContainer
//           component={Paper}
//           sx={{ boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2 }}
//         >
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>PICK UP</TableCell>
//                 <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>TRIP</TableCell>
//                 <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>REFERENCE</TableCell>
//                 <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 250 }}>
//                   EQUIPMENT
//                 </TableCell>
//                 {/* <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>ACTION</TableCell> */}
//               </TableRow>
//             </TableHead>

//             {!loading && (
//               <TableBody>
//                 {shipmentList.map((truck, index) => (
//                   <TableRow key={index}>
//                     <TableCell align="left">
//                       <Typography style={{ fontSize: 12, width: 75 }}>
//                         {moment(truck.pickup_earliest).format('MM/DD/YYYY')} -{' '}
//                         {moment(truck.pickup_lattest).format('MM/DD/YYYY')}
//                       </Typography>
//                     </TableCell>

//                     <TableCell
//                       align="left"
//                       sx={{
//                         fontSize: '12px',
//                         display: 'flex',
//                         flexDirection: 'column',
//                         justifyContent: 'center',
//                         alignItems: 'flex-start'
//                       }}
//                     >
//                       <div
//                         style={{
//                           display: 'flex',
//                           alignItems: 'flex-start',
//                           justifyContent: 'flex-start'
//                         }}
//                       >
//                         <p
//                           style={{
//                             fontWeight: 'bold',
//                             color: '#010f58',
//                             marginRight: 5,
//                             fontSize: 10
//                           }}
//                         >
//                           {truck?.total_mil || '-'}
//                         </p>
//                         <div>
//                           <div
//                             style={{
//                               display: 'flex',
//                               alignItems: 'center',
//                               justifyContent: 'flex-start',
//                               marginBottom: -5
//                             }}
//                           >
//                             <div
//                               style={{
//                                 height: 6,
//                                 width: 6,
//                                 borderRadius: 100,
//                                 backgroundColor: 'white',
//                                 border: '2px solid #010f58',
//                                 marginRight: 5
//                               }}
//                             ></div>
//                             <p
//                               style={{
//                                 whiteSpace: 'nowrap',
//                                 overflow: 'hidden',
//                                 textOverflow: 'ellipsis',
//                                 maxWidth: '150px' // Adjust this width as needed
//                               }}
//                             >
//                               {truck?.location_origin}
//                             </p>
//                           </div>
//                           <div>
//                             <Iconify
//                               icon="mingcute:arrow-down-line"
//                               style={{ fontSize: 14, marginLeft: -4.6, color: '#010f58' }}
//                             />
//                           </div>
//                           <div
//                             style={{
//                               display: 'flex',
//                               alignItems: 'center',
//                               justifyContent: 'flex-start',
//                               marginTop: -10
//                             }}
//                           >
//                             <div
//                               style={{
//                                 height: 6,
//                                 width: 6,
//                                 borderRadius: 100,
//                                 backgroundColor: '#010f58',
//                                 border: '2px solid #010f58',
//                                 marginRight: 5
//                               }}
//                             ></div>
//                             <p
//                               style={{
//                                 whiteSpace: 'nowrap',
//                                 overflow: 'hidden',
//                                 textOverflow: 'ellipsis',
//                                 maxWidth: '150px' // Adjust this width as needed
//                               }}
//                             >
//                               {truck?.location_destination}
//                             </p>
//                           </div>
//                         </div>
//                       </div>
//                     </TableCell>

//                     <TableCell sx={{ fontSize: '12px' }}>{truck.reference_id}</TableCell>

//                     <TableCell
//                       sx={{
//                         fontSize: '12px',
//                         fontSize: '12px',
//                         whiteSpace: 'nowrap',
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis'
//                       }}
//                     >
//                       <div style={{ display: 'flex' }}>
//                         <div style={{ display: 'flex', flexDirection: 'column', marginRight: 10 }}>
//                           <p>{truck?.equipment_type || '-'} </p>
//                           <p>{truck?.equipment_name || '-'} </p>
//                         </div>
//                         <div
//                           style={{
//                             flex: 1,
//                             display: 'flex',
//                             flexDirection: 'column',
//                             alignItems: 'flex-end',
//                             justifyContent: 'center'
//                           }}
//                         >
//                           <p>
//                             {truck.length_ft} {truck?.length_unit}
//                           </p>
//                           <p>
//                             {truck.weight_lbs} {truck?.weight_unit}
//                           </p>
//                         </div>
//                       </div>
//                     </TableCell>

//                     <TableCell>
//                       {selected.length === 0 && (
//                         <IconButton onClick={(e) => handleMenuClick(e, truck)}>
//                           <Iconify icon="iwwa:option" style={{ fontSize: 20, color: '#010f58' }} />
//                         </IconButton>
//                       )}
//                       <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
//                         <MenuItem sx={{ fontSize: 12 }}>Invite</MenuItem>
//                         <MenuItem sx={{ fontSize: 12 }} onClick={handleOpenDetailsModal}>
//                           View Profile
//                         </MenuItem>
//                       </Menu>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             )}

//             {/* loader */}
//             {loading && (
//               <TableBody>
//                 <TableRow>
//                   <TableCell align="center" colSpan={4} sx={{ py: 3 }}>
//                     <CircularProgress />
//                   </TableCell>
//                 </TableRow>
//               </TableBody>
//             )}

//             {/* empty list */}
//             {shipmentList.length == 0 && !loading && (
//               <TableBody>
//                 <TableRow>
//                   <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
//                     <Box
//                       display="flex"
//                       flexDirection="column"
//                       justifyContent="center"
//                       alignItems="center"
//                       height="55vh"
//                     >
//                       <img
//                         src={Empty_Truck}
//                         alt="No Shipment"
//                         style={{ width: '130px', marginBottom: '20px', marginRight: 40 }}
//                       />
//                       <Typography variant="h6" gutterBottom>
//                         You haven't added any shipment yet
//                       </Typography>
//                       <Typography variant="caption" color="textSecondary" gutterBottom>
//                         Add and save shipment details that can be used to save time when creating
//                         new posts.
//                       </Typography>
//                     </Box>
//                   </TableCell>
//                 </TableRow>
//               </TableBody>
//             )}
//           </Table>
//         </TableContainer>

//         {/* Pagination */}
//         {!loading && pagesCount > 1 && shipmentList.length !== 0 && (
//           <Box
//             style={{
//               display: 'flex',
//               flexDirection: 'row',
//               justifyContent: 'flex-end',
//               marginTop: 20,
//               alignItems: 'center',
//               marginBottom: 20
//             }}
//           >
//             <Pagination
//               color="primary"
//               shape="rounded"
//               page={page}
//               size="small"
//               count={pagesCount}
//               onChange={handlePageChange}
//               renderItem={(item) => <PaginationItem {...item} />}
//             />
//           </Box>
//         )}

//         <Dialog open={openDetailsModal} onClose={handleCloseDetailsModal} fullWidth>
//           <DialogTitle
//             style={{
//               height: 50,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               paddingLeft: 20,
//               paddingRight: 10,
//               marginBottom: 0
//             }}
//           >
//             Profile Information
//             <IconButton onClick={handleCloseDetailsModal}>
//               <Iconify icon="ic:round-clear" style={{ fontSize: 19 }} />
//             </IconButton>
//           </DialogTitle>
//           <DialogContent style={{ paddingLeft: 20, paddingTop: 0 }}>
//             <Box sx={{ mt: 2 }}>
//               <Box>
//                 <Grid
//                   container
//                   sx={{
//                     width: '100%',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'center',
//                     alignItems: 'flex-start'
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       width: '100%',
//                       display: 'flex',
//                       justifyContent: 'center',
//                       alignItems: 'flex-start',
//                       marginBottom: 0.5
//                     }}
//                   >
//                     <Typography sx={{ width: '22%', color: 'grey', fontSize: 12 }}>
//                       Name :
//                     </Typography>
//                     <Typography sx={{ flex: 1, fontSize: 12 }}>
//                       {/* {selectLoad?.company?.company
//                         ? selectLoad?.company?.company
//                         : selectLoad?.company?.first_name + ' ' + selectLoad?.company?.last_name} */}
//                       Shipment Name
//                     </Typography>
//                   </Box>
//                   <Box
//                     sx={{
//                       width: '100%',
//                       display: 'flex',
//                       justifyContent: 'center',
//                       alignItems: 'flex-start',
//                       marginBottom: 0.5
//                     }}
//                   >
//                     <Typography sx={{ width: '22%', color: 'grey', fontSize: 12 }}>
//                       Total Shipment :
//                     </Typography>
//                     <Typography sx={{ flex: 1, fontSize: 12 }}>20</Typography>
//                   </Box>
//                   <Box
//                     sx={{
//                       width: '100%',
//                       display: 'flex',
//                       justifyContent: 'center',
//                       alignItems: 'flex-start',
//                       marginBottom: 0.5
//                     }}
//                   >
//                     <Typography sx={{ width: '22%', color: 'grey', fontSize: 12 }}>
//                       Review and Rating :
//                     </Typography>
//                     <Typography sx={{ flex: 1, fontSize: 12 }}>
//                       {/* {selectLoad?.company?.score} */}
//                       20
//                     </Typography>
//                   </Box>
//                 </Grid>
//               </Box>
//             </Box>
//           </DialogContent>
//         </Dialog>

//         <Dialog open={open} onClose={handleClose} maxWidth="xs">
//           <DialogTitle>Extend Pickup Latest Date</DialogTitle>
//           <DialogContent>
//             <Typography sx={{ fontSize: 12 }}>
//               Your posts will be automatically refreshed every morning, up to the last pickup date.
//             </Typography>
//             <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
//               <LoadingButton
//                 size="small"
//                 onClick={handleDecrement}
//                 style={{
//                   justifyContent: 'center',
//                   width: 30, // Less than 30
//                   height: 30, // Ensuring it's a square button
//                   minWidth: 30, // Ensuring minimum width is set to 30
//                   padding: 0, // Removing padding to fit the icon properly
//                   lineHeight: 1, // Ensuring the icon is centered
//                   alignSelf: 'center',
//                   marginLeft: 0.5,
//                   backgroundColor: 'rgba(255, 72, 66, 0.16)',
//                   color: '#FF4842',
//                   border: '1.5px solid rgba(255, 72, 66, 0.5)'
//                 }}
//                 to="#"
//               >
//                 <Remove sx={{ fontSize: 15 }} />
//               </LoadingButton>
//               <TextField
//                 variant="outlined"
//                 value={days}
//                 style={{ width: '30%', textAlign: 'center', margin: '0px 10px' }}
//                 inputProps={{ min: 1, style: { textAlign: 'center' } }}
//                 readOnly
//                 disabled={true}
//                 className="custom-textfield"
//               />
//               <LoadingButton
//                 size="small"
//                 onClick={handleIncrement}
//                 style={{
//                   justifyContent: 'center',
//                   width: 30, // Less than 30
//                   height: 30, // Ensuring it's a square button
//                   minWidth: 30, // Ensuring minimum width is set to 30
//                   padding: 0, // Removing padding to fit the icon properly
//                   lineHeight: 1, // Ensuring the icon is centered
//                   alignSelf: 'center',
//                   marginLeft: 0.5,
//                   backgroundColor: 'rgba(84, 214, 44, 0.16)',
//                   color: '#54D62C',
//                   border: '1.5px solid rgba(84, 214, 44, 0.5)'
//                 }}
//                 to="#"
//               >
//                 <Add sx={{ fontSize: 15 }} />
//               </LoadingButton>
//             </div>
//           </DialogContent>
//           <DialogActions sx={{ marginTop: -2 }}>
//             <Button onClick={handleClose} color="primary">
//               Cancel
//             </Button>
//             <LoadingButton loading={extendLoading} onClick={ExtendDaysFuntion} color="primary">
//               Extend
//             </LoadingButton>
//           </DialogActions>
//         </Dialog>

//         <Dialog
//           open={openAlertModal}
//           onClose={handleCloseAlert}
//           aria-labelledby="alert-dialog-title"
//           aria-describedby="alert-dialog-description"
//         >
//           <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
//           <DialogContent>
//             <DialogContentText id="alert-dialog-description">
//               Are you sure you want to proceed?
//             </DialogContentText>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseAlert} color="primary">
//               No
//             </Button>
//             <LoadingButton
//               variant="contained"
//               loading={optionsLoader}
//               onClick={() => {
//                 handleOptionSelect('4');
//               }}
//               color="primary"
//               autoFocus
//             >
//               Yes
//             </LoadingButton>
//           </DialogActions>
//         </Dialog>

//         {/* RATING */}
//         <Dialog
//           open={openRatingModal}
//           onClose={handleCloseRating}
//           aria-labelledby="alert-dialog-title"
//           aria-describedby="alert-dialog-description"
//           // sx={{ width: "70%" }}
//           fullWidth
//         >
//           <DialogTitle id="alert-dialog-title">{'Rating & Review'}</DialogTitle>
//           <DialogContent>
//             <Rating name="simple-controlled" value={rating} onChange={handleRatingChange} />
//             <TextField
//               fullWidth
//               margin="normal"
//               label="Your Review"
//               multiline
//               rows={4}
//               variant="outlined"
//               value={review}
//               onChange={handleReviewChange}
//               style={{ fontSize: 12 }}
//             />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseRating} color="primary">
//               Cancel
//             </Button>
//             <LoadingButton
//               variant="contained"
//               loading={optionsLoader}
//               onClick={handleAddRatingReview}
//               color="primary"
//               autoFocus
//             >
//               Submit
//             </LoadingButton>
//           </DialogActions>
//         </Dialog>

//         <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
//           <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
//             {snackbarMessage}
//           </Alert>
//         </Snackbar>
//       </Container>
//     </Page>
//   );
// }
import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Container,
  Typography,
  Snackbar,
  Alert,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Checkbox,
  IconButton,
  MenuItem,
  Menu,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Pagination,
  PaginationItem,
  Grid,
  Avatar,
  Rating,
  TextField
} from '@mui/material';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import Page from '../../components/Page';
import Iconify from 'src/components/Iconify';

//icons
import Empty_Truck from '../../../src/asset/open-door.png';
import { api } from 'src/Api';
import { LoadingButton } from '@mui/lab';
import moment from 'moment';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import { TableNoData } from 'src/components/NoData';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CloseIcon from '@mui/icons-material/Close';
import { NumericFormat } from 'react-number-format';
import BookerProfileComponent from 'src/components/BookerProfileComponent';
import ReactQuill from 'react-quill';
import ShiperProfileComponent from 'src/components/ShiperProfileComponent';

export default function ShipmentTruckRequest() {
  const navigate = useNavigate();
  const location = useLocation();
  const { truck_id } = location.state || {};
  const userData = JSON.parse(localStorage.getItem('user'));

  const [trucksList, setTrucksList] = useState([]);

  const [loading, setloading] = useState(false);
  const [loadingCompany, setloadingCompany] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [anchorEl, setAnchorEl] = useState(null); // For 3-dot menu control
  const [selectedTruck, setSelectedTruck] = useState(null); // Track which truck is selected for menu
  const [companyData, setCompanyData] = useState(null); // Track which truck is selected for menu

  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = useState(1);

  const [openDetailsModal, setOpenDetailsModal] = useState(false);

  const [searchLoading, setsearchLoading] = useState(false);
  const [loadingInvite, setloadingInvite] = useState(false);
  const [search, setsearch] = useState('');

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [milesFilter, setMilesFilter] = useState('');

  const [message, setMessage] = useState('');
  const [openInviteDialog, setOpenInviteDialog] = useState(false);

  useEffect(() => {
    if (search.length == 0) {
      trucksList.length = 0;
      getRequestTruck(page);
    }
  }, [search]);

  useEffect(() => {
    getRequestTruck(page);
  }, [page, startDate, endDate, milesFilter]);

  // const handleInviteFunction = () => {
  //   if (message) {
  //     sendMessage();
  //     handleSendInvitation();
  //   } else {
  //     handleSendInvitation();
  //   }
  // };

  function getRequestTruck(page) {
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    search.length > 0 && queryParams.append('search', search);
    page && queryParams.append('page', page);
    queryParams.append('booking_id', truck_id);
    startDate && queryParams.append('start_date', moment(startDate).format('YYYY-MM-DD'));
    endDate && queryParams.append('end_date', moment(endDate).format('YYYY-MM-DD'));
    milesFilter && queryParams.append('miles', milesFilter);

    fetch(`${api.get_request_a_shipment}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setTrucksList(result.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 10)) : setpagesCount(1);
          setloading(false);
        } else {
          setTrucksList([]);
          setpagesCount(0);
          setloading(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloading(false);
      });
  }

  function getRequestTruckProfile() {
    setloadingCompany(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    queryParams.append('user_id', selectedTruck?.company?.id);
    queryParams.append('profile_type', 'Booker');

    fetch(`${api.get_profiles}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setCompanyData(result.data[0]);
          handleOpenDetailsModal();
          setloadingCompany(false);
        } else {
          setloadingCompany(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloadingCompany(false);
      });
  }

  const handleOpenInviteDialog = () => {
    setOpenInviteDialog(true);
    setAnchorEl(null);
  };

  const handleCloseInviteDialog = () => {
    setOpenInviteDialog(false);
    setMessage('');
  };

  function handleSendInvitation() {
    setloadingInvite(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    queryParams.append('request_id', truck_id);
    queryParams.append('request_to_id', selectedTruck?.company?.id);
    queryParams.append('request_by', 'Booker');
    queryParams.append('booking_id', selectedTruck?.id);
    message && queryParams.append('message', message);

    fetch(`${api.send_invitation}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setloadingInvite(false);
          handleMenuClose();
          handleCloseInviteDialog();
        } else {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
          setloadingInvite(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setloadingInvite(false);
      });
  }

  const handleMenuClick = (event, truck) => {
    setAnchorEl(event.currentTarget);
    setSelectedTruck(truck); // Set the truck for which menu is open
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedTruck(null); // Reset the selected truck
  };

  const handleOpenDetailsModal = () => {
    setOpenDetailsModal(true);
    setAnchorEl(null);
  };

  const handleCloseDetailsModal = () => {
    setOpenDetailsModal(false);
    setSelectedTruck(null);
  };

  const handlePageChange = (event, value) => {
    trucksList.length = 0;
    setPage(value);
    getRequestTruck(value);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleStartDateChange = (value) => {
    setStartDate(value ? value.toISOString() : null);
  };

  const handleEndDateChange = (value) => {
    setEndDate(value ? value.toISOString() : null);
  };
  const handleClearFilter = () => {
    setStartDate(null);
    setEndDate(null);
    setMilesFilter('');
  };

  return (
    <Page title={`My Trucks  | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={2}>
          <IconButton
            style={{
              marginRight: 12,
              height: 40,
              width: 70,
              borderRadius: 5,
              backgroundColor: 'rgba(209,209,209,0.3)'
            }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#010f58' }} />
          </IconButton>
          <Typography variant="h4" sx={{ color: '#010f58' }}>
            Request a Shipment
          </Typography>
        </Stack>

        <Box sx={{ marginTop: 2 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={3.62} md={3.66}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="custom-textfield"
                  sx={{ width: '100%' }}
                  label="Start Date"
                  value={startDate ? dayjs(startDate) : null}
                  onChange={(newValue) => handleStartDateChange(newValue)}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={3.62} md={3.66}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="custom-textfield"
                  sx={{ width: '100%' }}
                  label="End Date"
                  value={endDate ? dayjs(endDate) : null}
                  onChange={(newValue) => handleEndDateChange(newValue)}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={3.62} md={3.66}>
              <TextField
                sx={{ width: '100%' }}
                className="custom-textfield"
                type="number"
                placeholder="Miles"
                value={milesFilter}
                onChange={(e) => {
                  setMilesFilter(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={1} md={1}>
              <Button
                variant="contained"
                color="primary"
                sx={{ height: 50, width: '100%' }}
                onClick={handleClearFilter}
              >
                <CloseIcon />
              </Button>
            </Grid>
          </Grid>
        </Box>

        {/* Search bar */}
        <Box
          style={{
            flexDirection: 'column',
            display: 'flex',
            flex: 1,
            marginTop: 10
          }}
          className="top_column"
        >
          <Box
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1
            }}
            className="top_column"
          >
            <Searchbar
              width={'100%'}
              fullWidth
              setFunction={(val) => {
                setsearch(val);
              }}
              className="width_full_property"
              placeholder={'Search Requests'}
              onEnter={() => {
                setsearchLoading(true);
                trucksList.length = 0;
                getRequestTruck();
              }}
            />
            <LoadingButton
              style={{ width: '15%', marginLeft: '2%' }}
              variant="contained"
              className="width_full_status"
              loading={searchLoading}
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                getRequestTruck(1);
              }}
            >
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>
          </Box>
        </Box>

        <TableContainer
          component={Paper}
          sx={{ boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>COMPANY</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>TRUCK</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>RATE</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>REFERENCE</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>AVAILABLE</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>TRIP</TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontSize: '12px',
                    color: '#010f58',
                    position: 'sticky',
                    right: 0,
                    zIndex: 1,
                    backgroundColor: '#fff',
                    width: 80
                  }}
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            {!loading && (
              <TableBody>
                {trucksList.map((truck, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell scope="row" padding="normal">
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Avatar
                            sx={{
                              width: 42, // Adjust size if needed
                              height: 42,
                              objectFit: 'contain'
                            }}
                            alt={truck?.company?.company}
                            src={truck?.company?.avatar}
                          />
                          <Box style={{ display: 'flex', flexDirection: 'column', width: 120 }}>
                            <Typography variant="subtitle2" flexWrap={'wrap'}>
                              {truck?.company?.company || 'N/A'}
                            </Typography>
                          </Box>
                        </Stack>
                      </TableCell>

                      <TableCell>
                        <Typography style={{ fontSize: 12, width: 170 }}>
                          {`${truck?.equipment_type || '-'} | ${truck?.equipment_name || '-'} | ${
                            truck?.weight_lbs || '-'
                          } ${truck?.weight_unit || '-'} | ${truck?.length_ft || '-'} ${
                            truck?.length_unit || '-'
                          }`}
                        </Typography>
                      </TableCell>

                      <TableCell style={{ fontSize: 12, width: 75 }}>
                        {truck.rate ? (
                          <NumericFormat
                            value={truck.rate ? parseFloat(truck.rate).toFixed(2) : '0.00'}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                          />
                        ) : (
                          '-'
                        )}
                      </TableCell>
                      <TableCell style={{ fontSize: 12, width: 75 }}>
                        {truck?.reference_id}
                      </TableCell>

                      <TableCell>
                        {truck?.available}
                        <Typography style={{ fontSize: 12, width: 75 }}>
                          {moment(truck?.startdate).format('MM/DD/YYYY')} -{' '}
                          {moment(truck?.enddate).format('MM/DD/YYYY')}
                        </Typography>
                      </TableCell>

                      <TableCell sx={{ fontSize: '12px' }}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'flex-start'
                          }}
                        >
                          <p
                            style={{
                              fontWeight: 'bold',
                              color: '#010f58',
                              marginRight: 5,
                              fontSize: 10
                            }}
                          >
                            {truck?.total_mil || '-'}
                          </p>
                          <div>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                marginBottom: -5
                              }}
                            >
                              <div
                                style={{
                                  height: 6,
                                  width: 6,
                                  borderRadius: 100,
                                  backgroundColor: 'white',
                                  border: '2px solid #010f58',
                                  marginRight: 5
                                }}
                              ></div>
                              <p
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '150px' // Adjust this width as needed
                                }}
                              >
                                {truck?.location_origin}
                              </p>
                            </div>
                            <div>
                              <Iconify
                                icon="mingcute:arrow-down-line"
                                style={{ fontSize: 14, marginLeft: -4.6, color: '#010f58' }}
                              />
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                marginTop: -10
                              }}
                            >
                              <div
                                style={{
                                  height: 6,
                                  width: 6,
                                  borderRadius: 100,
                                  backgroundColor: '#010f58',
                                  border: '2px solid #010f58',
                                  marginRight: 5
                                }}
                              ></div>
                              <p
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '150px' // Adjust this width as needed
                                }}
                              >
                                {truck?.location_destination}
                              </p>
                            </div>
                          </div>
                        </div>
                      </TableCell>

                      <TableCell
                        align="right"
                        style={{
                          position: 'sticky',
                          right: 0,
                          zIndex: 1,
                          background: '#fff'
                        }}
                      >
                        <IconButton onClick={(e) => handleMenuClick(e, truck)}>
                          <Iconify icon="iwwa:option" style={{ fontSize: 20, color: '#010f58' }} />
                        </IconButton>
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleMenuClose}
                        >
                          <MenuItem
                            sx={{ fontSize: 12 }}
                            onClick={handleOpenInviteDialog}
                            disabled={truck?.request_status}
                          >
                            {/* {loadingInvite ? (
                                <CircularProgress size={12} sx={{ alignContent: 'center' }} />
                              ) : ( */}
                            Invite
                            {/* )} */}
                          </MenuItem>
                          <MenuItem
                            sx={{ fontSize: 12, width: 100 }}
                            onClick={getRequestTruckProfile}
                          >
                            {loadingCompany ? (
                              <CircularProgress size={12} sx={{ alignContent: 'center' }} />
                            ) : (
                              'View Profile'
                            )}
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            )}

            {/* loader */}
            {loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {/* empty list */}
            {trucksList.length == 0 && !loading && <TableNoData colSpan={7} />}
          </Table>
        </TableContainer>

        {/* Pagination */}
        {!loading && pagesCount > 1 && trucksList.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 20,
              alignItems: 'center',
              marginBottom: 20
            }}
          >
            <Pagination
              color="primary"
              shape="rounded"
              page={page}
              size="small"
              count={pagesCount}
              onChange={handlePageChange}
              renderItem={(item) => <PaginationItem {...item} />}
            />
          </Box>
        )}

        <ShiperProfileComponent
          companyData={companyData}
          onClose={handleCloseDetailsModal}
          open={openDetailsModal}
        />

        <Dialog open={openInviteDialog} onClose={handleCloseInviteDialog} fullWidth>
          <DialogTitle>Send Invitation</DialogTitle>
          <DialogContent>
            <ReactQuill
              modules={{
                toolbar: [
                  [{ header: [1, 2, false] }],
                  ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                  [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
                  ['link', 'image'],
                  ['emoji'],
                  ['clean']
                ],
                'emoji-toolbar': true,
                'emoji-textarea': false,
                'emoji-shortname': true
              }}
              value={message}
              onChange={setMessage}
              placeholder="Write your message..."
              style={{ marginBottom: 10 }}
            />
          </DialogContent>
          <DialogActions sx={{ paddingRight: 3, paddingBottom: 2 }}>
            <Button onClick={handleCloseInviteDialog} color="primary">
              Cancel
            </Button>
            <LoadingButton
              loading={loadingInvite}
              onClick={handleSendInvitation}
              color="primary"
              variant="contained"
            >
              Send
            </LoadingButton>
          </DialogActions>
        </Dialog>

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
